module.exports = __webpack_public_path__ + "img/4_no.240e5ab4.svg";